import { formatNumberToAbbreviation } from 'utils/helpers';
import type { Artist } from 'types';

// "Genre · Location · Listeners" — the artist meta line shown under an artist's name across
// the Collab Club admin (requests list, profile cards).
export const artistMetaLine = (artist: Artist | null): string => {
  if (!artist) return '';
  const listeners = artist.monthlyListeners ? Number(artist.monthlyListeners) : null;
  return [
    artist.genres?.[0],
    artist.location,
    listeners != null ? `${formatNumberToAbbreviation(listeners)} listeners` : null,
  ]
    .filter(Boolean)
    .join(' · ');
};
